
export default class Hooks {
  constructor(context) {
    this._cxt = context;
  }

  async handle() {
    this._cxt.store.subscribeAction({
      before: async (action, state) => {
        // --- //
      },
      after: async (action, state) => {
        if ((action.type === '_core/auth/processSignIn'
          || action.type === '_core/auth/actionSignIn'
          || action.type === '_core/auth/actionAssumeRole')
          && state._core.auth.currentRole) {
          setTimeout(async ()=>{
            await this._cxt.store.dispatch('plataforma/user/actionGetUserRolesContext', _, { root: true });
            await this._cxt.store.dispatch('plataforma/institutionConfiguration/actionGetInstitutionConfiguration', _, { root: true });
            await this._cxt.store.dispatch('plataforma/terms/getAll', _, { root: true });
          });
        };
      }
    });
  }
}
